"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomTabs = exports.SignContent = void 0;
const react_1 = __importStar(require("react"));
const formik_1 = require("formik");
const yup = __importStar(require("yup"));
const clsx_1 = __importDefault(require("clsx"));
const Button_1 = __importDefault(require("@material-ui/core/Button"));
const Typography_1 = __importDefault(require("@material-ui/core/Typography"));
const Tab_1 = __importDefault(require("@material-ui/core/Tab"));
const Tabs_1 = __importDefault(require("@material-ui/core/Tabs"));
const makeStyles_1 = __importDefault(require("@material-ui/styles/makeStyles"));
const Box_1 = __importDefault(require("@material-ui/core/Box"));
const Link_1 = __importDefault(require("@material-ui/core/Link"));
const Divider_1 = __importDefault(require("@material-ui/core/Divider"));
const TextField_1 = __importDefault(require("@material-ui/core/TextField"));
const CallMade_1 = __importDefault(require("@material-ui/icons/CallMade"));
const shared_hooks_use_boolean_1 = require("@guidde-co/shared.hooks.use-boolean");
const GoogleIcon = () => (react_1.default.createElement("svg", { width: "21", height: "21", viewBox: "0 0 256 262", xmlns: "http://www.w3.org/2000/svg", preserveAspectRatio: "xMidYMid" },
    react_1.default.createElement("path", { d: "M255.878 133.451c0-10.734-.871-18.567-2.756-26.69H130.55v48.448h71.947c-1.45 12.04-9.283 30.172-26.69 42.356l-.244 1.622 38.755 30.023 2.685.268c24.659-22.774 38.875-56.282 38.875-96.027", fill: "#4285F4" }),
    react_1.default.createElement("path", { d: "M130.55 261.1c35.248 0 64.839-11.605 86.453-31.622l-41.196-31.913c-11.024 7.688-25.82 13.055-45.257 13.055-34.523 0-63.824-22.773-74.269-54.25l-1.531.13-40.298 31.187-.527 1.465C35.393 231.798 79.49 261.1 130.55 261.1", fill: "#34A853" }),
    react_1.default.createElement("path", { d: "M56.281 156.37c-2.756-8.123-4.351-16.827-4.351-25.82 0-8.994 1.595-17.697 4.206-25.82l-.073-1.73L15.26 71.312l-1.335.635C5.077 89.644 0 109.517 0 130.55s5.077 40.905 13.925 58.602l42.356-32.782", fill: "#FBBC05" }),
    react_1.default.createElement("path", { d: "M130.55 50.479c24.514 0 41.05 10.589 50.479 19.438l36.844-35.974C195.245 12.91 165.798 0 130.55 0 79.49 0 35.393 29.301 13.925 71.947l42.211 32.783c10.59-31.477 39.891-54.251 74.414-54.251", fill: "#EB4335" })));
const IconMicrosoft = () => (react_1.default.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "21", height: "21", viewBox: "0 0 21 21" },
    react_1.default.createElement("title", null, "MS-SymbolLockup"),
    react_1.default.createElement("rect", { x: "1", y: "1", width: "9", height: "9", fill: "#f25022" }),
    react_1.default.createElement("rect", { x: "1", y: "11", width: "9", height: "9", fill: "#00a4ef" }),
    react_1.default.createElement("rect", { x: "11", y: "1", width: "9", height: "9", fill: "#7fba00" }),
    react_1.default.createElement("rect", { x: "11", y: "11", width: "9", height: "9", fill: "#ffb900" })));
const LetterIcon = () => (react_1.default.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
    react_1.default.createElement("path", { d: "M20 5.93066V17.9307C20 19.0307 19.1 19.9307 18 19.9307H6C4.9 19.9307 4 19.0307 4 17.9307V5.93066C4 4.83066 4.9 3.93066 6 3.93066H18C19.1 3.93066 20 4.83066 20 5.93066ZM18 5.93066H6V17.9307H18V5.93066Z", fill: "currentColor" }),
    react_1.default.createElement("path", { d: "M5 7L12 12L19 7", stroke: "currentColor", strokeWidth: "2" })));
const SecureKeyIcon = () => (react_1.default.createElement("svg", { width: "17", height: "20", viewBox: "0 0 17 20", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg" },
    react_1.default.createElement("path", { d: "M8.37117 18.4829L8.5 18.5172L8.62883 18.4829C12.646 17.4116 15 13.7121 15 9.21977V5.29977V4.95596L14.679 4.8329L8.67897 2.53288L8.5 2.46428L8.32103 2.53288L2.32103 4.8329L2 4.95596V5.29977V9.21977C2 13.7121 4.35398 17.4116 8.37117 18.4829ZM9.33465 10.3579L9 10.4752V10.8298V11.9998V12.4998H9.5H11V13.4998H9.5H9V13.9998V15.4998H8V10.8298V10.4752L7.66535 10.3579C6.69115 10.0165 6 9.09247 6 7.99977C6 7.33673 6.26339 6.70084 6.73223 6.232C7.20107 5.76316 7.83696 5.49977 8.5 5.49977C9.16304 5.49977 9.79893 5.76316 10.2678 6.232C10.7366 6.70084 11 7.33673 11 7.99977C11 9.09247 10.3089 10.0165 9.33465 10.3579ZM16 8.99977C16 11.6903 15.312 14.0188 14.028 15.8181C12.7674 17.5845 10.913 18.8689 8.5 19.4844C6.08705 18.8689 4.23256 17.5845 2.97199 15.8181C1.68798 14.0188 1 11.6903 1 8.99977V4.33907L8.5 1.35781L16 4.33907V8.99977ZM8.5 6.49977C8.10217 6.49977 7.72064 6.65781 7.43934 6.93911C7.15804 7.22042 7 7.60195 7 7.99977C7 8.3976 7.15804 8.77913 7.43934 9.06043C7.72064 9.34174 8.10217 9.49977 8.5 9.49977C8.89783 9.49977 9.27936 9.34174 9.56066 9.06043C9.84196 8.77913 10 8.3976 10 7.99977C10 7.60195 9.84196 7.22042 9.56066 6.93911C9.27936 6.65781 8.89783 6.49977 8.5 6.49977Z", fill: "currentColor", stroke: "currentColor" })));
const useStyles = (0, makeStyles_1.default)({
    static: {
        background: '#CB0000',
        color: '#fff',
        width: '35vw'
    },
    or: {
        margin: '0 8px',
        whiteSpace: 'nowrap'
    },
    logoIcon: {
        width: '25px',
        height: '25px'
    },
    center: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center'
    },
    form: {
        height: '100%',
        width: '65vw',
        ['@media (min-width:600)']: {
            width: '100vw'
        }
    },
    button: {
        borderRadius: 4,
        border: '1px solid #E0E0E0',
        overflow: 'hidden',
        textTransform: 'uppercase',
        letterSpacing: '1.25px',
        color: 'rgba(9, 12, 16, 0.6)'
    },
    inputRoot: {
        borderRadius: '4px',
        overflow: 'hidden',
        background: '#FAFAFA',
        padding: '4px 8px',
        fontSize: '12px'
    },
    inputMultiline: {
        paddingTop: '10px',
        borderRadius: '4px'
    },
    counter: {
        paddingRight: '4px',
        paddingTop: '4px',
        fontSize: '12px',
        color: '#828282'
    },
    message: {
        background: '#CB0000',
        color: '#fff',
        borderRadius: '4px',
        marginTop: 16,
        padding: 12
    },
    input: {
        '& :before': {
            borderBottomColor: '#e0e0e0'
        }
    },
    wrapper: {
        display: 'flex',
        flexDirection: 'row',
        borderRadius: '4px',
        minHeight: '25px',
        background: 'transparent',
        width: '50%',
        '& svg': {
            minWidth: '25px',
            marginBottom: '0 !important',
            marginRight: 4,
            color: '#828282'
        }
    },
    root: {
        minHeight: '25px',
        background: '#F5F5F5',
        borderRadius: '4px'
    },
    tabRoot: {
        minHeight: '25px',
        padding: '4px',
        display: 'flex',
        flex: 1,
        width: '100%'
    },
    indicator: {
        display: 'none'
    },
    scroller: {
        padding: 0,
        '& span': {
            width: '100%'
        },
        '& [aria-selected="true"]': {
            '& span:first-child': {
                background: '#FFFFFF',
                boxShadow: '0px 0px 4px 0px #0000001A'
            }
        }
    },
    selected: {
        '& svg': {
            color: '#CB0000'
        }
    }
});
const SignContent = ({ googleLabel, microsoftLabel, alternativeText, subtitle, analyticKey, label, emailValue, title, initialTab = 0, alternativeLabel, isMobileView, hideTabs, decreaseMargins = 1, mobileMaxWidth = 380, onAlternativeLabelClick = () => { }, onMicrosoftClick, onGoogleClick, onSubmit }) => {
    const classes = useStyles();
    const ssoError = (0, shared_hooks_use_boolean_1.useBoolean)();
    const emailMessage = (0, shared_hooks_use_boolean_1.useBoolean)();
    const [tabValue, setTabValue] = (0, react_1.useState)(initialTab);
    const getSpacing = number => number / decreaseMargins;
    return (react_1.default.createElement(Box_1.default, { className: (0, clsx_1.default)(classes.form, classes.center) },
        react_1.default.createElement(Box_1.default, { style: {
                maxWidth: isMobileView ? `${mobileMaxWidth}px` : '410px',
                width: '100%',
                padding: `${getSpacing(30)}px`
            } },
            react_1.default.createElement(Typography_1.default, { variant: "subtitle1" }, title),
            subtitle && (react_1.default.createElement(Typography_1.default, { variant: "caption" }, subtitle)),
            react_1.default.createElement(Box_1.default, { mt: getSpacing(3.5) }),
            react_1.default.createElement(LoginButton, { Icon: GoogleIcon, onClick: onGoogleClick, label: googleLabel }),
            react_1.default.createElement(Box_1.default, { mt: 1 }),
            react_1.default.createElement(LoginButton, { Icon: IconMicrosoft, onClick: onMicrosoftClick, label: microsoftLabel }),
            react_1.default.createElement(Box_1.default, { display: "flex", alignItems: "center", justifyContent: "space-between", my: getSpacing(4) },
                react_1.default.createElement(Divider_1.default, { style: { width: '45%' } }),
                react_1.default.createElement(Typography_1.default, { variant: "caption", align: "center", color: "textSecondary" }, "or"),
                react_1.default.createElement(Divider_1.default, { style: { width: '45%' } })),
            !hideTabs && (react_1.default.createElement(exports.CustomTabs, { value: tabValue, onChange: val => {
                    ssoError.setFalse();
                    emailMessage.setFalse();
                    setTabValue(val);
                }, tabs: [
                    { label: 'Email', icon: react_1.default.createElement(LetterIcon, null) },
                    { label: 'SSO', icon: react_1.default.createElement(SecureKeyIcon, null) }
                ] })),
            react_1.default.createElement(formik_1.Formik, { onSubmit: (values, { resetForm, setSubmitting }) => {
                    const email = values.email.trim() || '';
                    const domain = email.substring(email.lastIndexOf('@') + 1);
                    onSubmit({
                        email,
                        domain,
                        tabValue,
                        resetForm,
                        setSubmitting,
                        setEmailError: emailMessage.setTrue,
                        setSSOError: ssoError.setTrue
                    });
                }, initialValues: {
                    email: emailValue
                }, validationSchema: yup.object().shape({
                    email: yup
                        .string()
                        .trim()
                        .nullable()
                        .email('Enter valid email')
                        .required('Field is required')
                }) }, ({ isSubmitting, isValid, setFieldValue, values }) => (react_1.default.createElement(formik_1.Form, { style: { width: '100%' } },
                react_1.default.createElement(Box_1.default, { mt: getSpacing(2), mb: getSpacing(1) },
                    react_1.default.createElement(Typography_1.default, { variant: "caption" }, tabValue === 0
                        ? 'Email'
                        : 'Continue with your Single Sign-On provider to sign in')),
                react_1.default.createElement(TextField_1.default, { name: "email", value: values.email, onChange: e => {
                        var _a;
                        setFieldValue(e === null || e === void 0 ? void 0 : e.target.name, (_a = e === null || e === void 0 ? void 0 : e.target) === null || _a === void 0 ? void 0 : _a.value);
                        ssoError.setFalse();
                        emailMessage.setFalse();
                    }, InputProps: {
                        disableUnderline: true,
                        classes: {
                            root: classes.inputRoot,
                            multiline: classes.inputMultiline
                        }
                    }, fullWidth: true, classes: {
                        root: classes.input
                    }, "data-cy": `${analyticKey}-input`, placeholder: tabValue === 0
                        ? 'Please enter your email address'
                        : 'Email' }),
                ssoError.isTrue && (react_1.default.createElement(Box_1.default, { className: classes.message },
                    react_1.default.createElement(Typography_1.default, { variant: "body2", color: "inherit" }, "This email is not configured for SSO. Please contact your administrator"))),
                emailMessage.isTrue && (react_1.default.createElement(Box_1.default, { className: classes.message, "data-cy": "almost-there" },
                    react_1.default.createElement(Typography_1.default, { variant: "body2", color: "inherit", style: { fontWeight: 600 } }, "You're almost there! Thank you for signing in to Guidde!"),
                    react_1.default.createElement(Typography_1.default, { variant: "body2", color: "inherit" }, "Please check your email to continue"))),
                react_1.default.createElement(Box_1.default, { mt: getSpacing(3) }),
                react_1.default.createElement(Button_1.default, { "data-cy": `${analyticKey}-via-email`, disabled: isSubmitting || !isValid || !values.email, size: "small", type: "submit", startIcon: react_1.default.createElement(CallMade_1.default, { fontSize: "large", style: { transform: 'rotate(45deg)' } }) }, label)))),
            react_1.default.createElement(Box_1.default, { mt: getSpacing(3) }),
            react_1.default.createElement(Typography_1.default, { variant: "caption", color: "textSecondary" },
                "By using Guidde you are agreeing to our",
                ' ',
                react_1.default.createElement(Typography_1.default, { variant: "caption", align: "center", component: "span" },
                    react_1.default.createElement(Link_1.default, { href: "https://www.guidde.com/privacy-policy", target: "_blank", color: "inherit", underline: "always" }, "privacy policy"),
                    ' ',
                    "and",
                    ' ',
                    react_1.default.createElement(Link_1.default, { href: "https://www.guidde.com/legal", color: "inherit", target: "_blank", underline: "always" }, "terms"),
                    ".")),
            react_1.default.createElement(Box_1.default, null,
                react_1.default.createElement(Typography_1.default, { variant: "caption", align: "center", color: "textSecondary" },
                    alternativeText,
                    ' ',
                    react_1.default.createElement(Typography_1.default, { color: "primary", variant: "caption", component: "span", style: {
                            cursor: 'pointer',
                            textDecoration: 'underline'
                        }, onClick: onAlternativeLabelClick }, alternativeLabel))))));
};
exports.SignContent = SignContent;
const LoginButton = ({ onClick, Icon, label }) => {
    const classes = useStyles();
    return (react_1.default.createElement(Button_1.default, { fullWidth: true, disableRipple: true, variant: "outlined", color: "inherit", onClick: onClick, className: classes.button, startIcon: react_1.default.createElement(Icon, { width: 25, height: 25 }) },
        react_1.default.createElement(Box_1.default, { width: "calc(100% - 30px)", height: 30, ml: 4, display: "flex", alignItems: "center" }, label)));
};
const CustomTabs = (_a) => {
    var { onChange, value, tabs } = _a, rest = __rest(_a, ["onChange", "value", "tabs"]);
    const classes = useStyles();
    const [tabValue, setTabValue] = (0, react_1.useState)(0);
    (0, react_1.useEffect)(() => {
        setTabValue(value);
    }, [value]);
    return (react_1.default.createElement(Tabs_1.default, Object.assign({}, rest, { value: tabValue, classes: {
            indicator: classes.indicator,
            root: classes.root,
            scroller: classes.scroller
        }, onChange: (_e, value) => onChange(value) }), tabs.map((tab, i) => (react_1.default.createElement(Tab_1.default, { key: i, label: tab.label, icon: tab.icon, wrapped: true, classes: {
            root: classes.tabRoot,
            wrapper: classes.wrapper,
            selected: classes.selected
        } })))));
};
exports.CustomTabs = CustomTabs;
//# sourceMappingURL=sign-content.js.map